import { render, staticRenderFns } from "./correctDialog.vue?vue&type=template&id=89f48b72&scoped=true&"
import script from "./correctDialog.vue?vue&type=script&lang=js&"
export * from "./correctDialog.vue?vue&type=script&lang=js&"
import style0 from "./correctDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./correctDialog.vue?vue&type=style&index=1&id=89f48b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f48b72",
  null
  
)

export default component.exports